import { useEffect, useState } from 'react';
import styles from './SitePages.module.css';

/** Empty ids means all assigned locations. A custom selection is never empty. */
export function SiteScopePicker({ sites, ids, onChange }: {
  sites: ReadonlyArray<{ _id: string; name: string }>;
  ids: string[];
  onChange: (ids: string[]) => void;
}) {
  const [custom, setCustom] = useState(ids.length > 1);
  useEffect(() => { if (ids.length === 0) setCustom(false); }, [ids.length]);
  if (sites.length < 2) return null;
  return <fieldset className={styles.scopePicker}>
    <legend>Locations</legend>
    <select aria-label="Locations to compare" className={styles.select}
      value={custom || ids.length > 1 ? 'custom' : ids[0] ?? 'all'}
      onChange={(event) => {
        const value = event.target.value;
        setCustom(value === 'custom');
        onChange(value === 'all' ? [] : value === 'custom' ? (ids.length ? ids : sites.map((s) => s._id)) : [value]);
      }}>
      <option value="all">All locations</option>
      <option value="custom">Choose locations to compare</option>
      {sites.map((site) => <option key={site._id} value={site._id}>{site.name}</option>)}
    </select>
    {(custom || ids.length > 1) && <div className={styles.scopeChoices}>
      {sites.map((site) => <label key={site._id}>
        <input type="checkbox" checked={ids.includes(site._id)} disabled={ids.length === 1 && ids[0] === site._id}
          onChange={(event) => onChange(event.target.checked ? [...ids, site._id] : ids.filter((id) => id !== site._id))} />
        {site.name}
      </label>)}
    </div>}
  </fieldset>;
}
